import { Weapon, type WeaponConfig } from './Weapon';

const REVOLVER_CONFIG: WeaponConfig = {
  id: 'revolver',
  price: 0,
  fireRateMs: 250,
  bulletsPerShot: 1,
  spreadDeg: 0,
  soundKey: 'pistol_shot',
  soundVolume: 0.4,
  shakeShoot: null,
  magazineSize: 6,
  reloadTimeMs: 1275,
  fireMode: 'single',
  bulletWidth: 4,
  bulletHeight: 2,
};

export function createRevolver(): Weapon {
  return new Weapon(REVOLVER_CONFIG);
}
